import { CLASSIC_ICHING_WILHELM_NL_FEATURE_ID } from '../iching/iching.metadata';

/**
 * Community-content: door communityleden aangeleverde of beschermde teksten
 * die geen deel uitmaken van de standaard applicatie-content. Er zijn twee
 * packs: de Rave I'Ching Line Companion en de Nederlandse Wilhelm-tekst voor
 * Classic I Ching. Het concept is bewust breder opgezet zodat latere packs
 * (language packs, eigen vertalingen van bestaande app-teksten) op dezelfde
 * structuur kunnen meeliften: een pack-id, een asset-root per taal, en
 * toegang via een UPAM-feature (plus een opt-in-setting voor de Line Companion;
 * de Wilhelm-tekst hangt aan de eigen Classic I Ching-setting).
 */

/**
 * UPAM-page-feature "EnableCommunityLineContent" (gedeclareerd op de
 * chart-environment-pagina). Toekenning gebeurt handmatig in UPAM per
 * gebruikersgroep, net als de support-features. Vergelijking is
 * hoofdletterongevoelig.
 */
export const COMMUNITY_LINE_CONTENT_FEATURE_ID = 'c011ab00-0000-0000-0000-0000c011ab00';

/** Ondersteunde community-content-packs. */
export type CommunityContentPackId = 'line-companion' | 'iching-wilhelm-nl';

export interface CommunityContentPackDefinition {
  readonly id: CommunityContentPackId;
  /** Asset-root (zonder taal); bestanden staan onder `<root>/<lang>/...`. */
  readonly assetRoot: string;
  /** Talen waarvoor content-assets bestaan; andere talen vallen terug op 'en'. */
  readonly languages: readonly string[];
  /** UPAM-feature die toegang geeft tot dit pack. */
  readonly featureId: string;
}

export const COMMUNITY_CONTENT_PACKS: Record<CommunityContentPackId, CommunityContentPackDefinition> = {
  'line-companion': {
    id: 'line-companion',
    assetRoot: 'assets/community-content/line-companion',
    languages: ['en', 'nl'],
    featureId: COMMUNITY_LINE_CONTENT_FEATURE_ID,
  },
  'iching-wilhelm-nl': {
    id: 'iching-wilhelm-nl',
    assetRoot: 'assets/iching/wilhelm-nl',
    languages: ['nl'],
    featureId: CLASSIC_ICHING_WILHELM_NL_FEATURE_ID,
  },
};
